import AuthenticatedRequest from 'services/requests/Authenticated';
import apiUrlConfig from 'configs/apiUrlConfig';
import { addQueryParameters } from '../utils/url';

const URLS = {
  INDEX: `${apiUrlConfig.endPoint()}/api/admin/v1/business_addons`,
  ACTIVE_LIST: `${apiUrlConfig.endPoint()}//api/admin/v1/business_addons?active=true`,
};

class AddonsApi {
  static fetchAll(filter) {
    const FETCH_URL = addQueryParameters(URLS.INDEX, filter);
    return AuthenticatedRequest.get(FETCH_URL);
  }
}

export default AddonsApi;



// WEBPACK FOOTER //
// ./src/apis/Addons.js